// Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyB5z8qjqIP1LVH-Y2ZtBJsdYSJZZJN8QO0",
  authDomain: "sridhar-iyer-blog.firebaseapp.com",
  projectId: "sridhar-iyer-blog",
  storageBucket: "sridhar-iyer-blog.firebasestorage.app",
  messagingSenderId: "611954562556",
  appId: "1:611954562556:web:76bf44abe85faf78118e79"
}; 